jQuery(document).ready(function($){

  //alert($(document).width());

  $(".tx_welpload_pi1 > input").click(function() {
	 $(".tx_welpload_pi1").addClass("stayopen"); 
  });

  // Layer Click outside --------------- 
  $(document).click(function(){
    $('.ebene-zwei').stop(true,true).slideUp(700, 'easeOutCubic', function() {
      $('nav.main-navi > ul > li').removeClass('trigger-active');  
    });
  });

  // Layer Hide on resize --------------- 
  $( window ).resize(function() {  
    $('.ebene-zwei').stop(true,true).slideUp(700, 'easeOutCubic', function() {
      $('nav.main-navi > ul > li').removeClass('trigger-active');  
    });
  });

  // Layer Click inside --------------- 
  $(".ebene-zwei").click(function(event){
      event.stopPropagation();
  });

  // Navigation:ANFANG ---------------  
  $('nav.main-navi > ul > li.sub').hover(function(event) {
      //event.preventDefault();
      //event.stopPropagation();

      var trig = $(this);//.parent('li');

      if (trig.hasClass('trigger-active')) {
        trig.children('.ebene-zwei').stop(true,true).slideToggle(700, 'easeOutCubic');
        trig.removeClass('trigger-active'); 
      } else {      
        $('.trigger-active').children('.ebene-zwei').stop(true,true).slideToggle(700, 'easeOutCubic');
        $('.trigger-active').removeClass('trigger-active');
        trig.children('.ebene-zwei').stop(true,true).slideToggle(700, 'easeOutCubic');
        trig.addClass('trigger-active');            
      };
      return false;
  }, function(event) {
    var trig = $(this);//.parent('li');

      if (trig.hasClass('trigger-active')) {
        trig.children('.ebene-zwei').stop(true,true).slideToggle(700, 'easeOutCubic');
        trig.removeClass('trigger-active'); 
      } else {      
        $('.trigger-active').children('.ebene-zwei').stop(true,true).slideToggle(700, 'easeOutCubic');
        $('.trigger-active').removeClass('trigger-active');
        trig.children('.ebene-zwei').stop(true,true).slideToggle(700, 'easeOutCubic');
        trig.addClass('trigger-active');            
      };
      return false;
  }); 
  // Navigation:ENDE ---------------  


  // Mobile:ANFANG --------------- 
  
  $('.pushy li.mobile-btn.sub > a').click(function(event) {
      event.preventDefault(); 
      event.stopPropagation();     

      var trig = $(this);

      if (trig.hasClass('mobile-active')) {        
        trig.next('ul').stop(true,true).slideToggle(500);
        trig.removeClass('mobile-active'); 
      } else {      
        $('.mobile-active').next('ul').stop(true,true).slideToggle(500);
        $('.mobile-active').removeClass('mobile-active');
        trig.next('ul').stop(true,true).slideToggle(500);
        trig.addClass('mobile-active');            
      };
      return false;
  }); 
  
  // Mobile:ENDE --------------- 


  // Slick Slider:ANFANG ---------------
  $('.slideshow.head').slick({
    dots: false,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 8000,
    slidesToShow: 1,
    autoplay: true,
	arrows: false,
    responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: false
      }
    }
    ]
  });

  $('.slideshow.image-galery').slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true
  });  
  // Slick Slider:ENDE ---------------
  
  
  // Anchor Navigation with smooth Scroll
  $('a').on("click",function() {
	if($(this).attr("href").match("#")) {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		  var target = $(this.hash);
		  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		  if (target.length) {
			
			//if($(document).width() < 768) var scrollSpace = 150
			//else scrollSpace = 300
			scrollSpace = 110;
			
			$('html,body').animate({
			  scrollTop: (target.offset().top-scrollSpace)
			}, 1000);
			if($("body").hasClass("pushy-active")) $(".btn-close").trigger("click");
			return false;
		  }
		}
	}
  });
  if(location.href.match("#")) {
   obj = $("#"+location.href.split("#")[1]);
   if($("#"+location.href.split("#")[1]).length) {
	 //if($(document).width() < 768) var scrollSpace = 150
	 //else scrollSpace = 300 
	 scrollSpace = 110;
     $('html,body').animate({
       scrollTop: (obj.offset().top-scrollSpace)
     }, 1000);
   }
  }
   
   /*
   $(".pushy, .main-navi").find("a").each(function() {
	   switch(parseInt($(this).attr("data-anchor"))) {
		   case 3:
				$(this).attr("href","#page");
		   break;
		   case 4:
				$(this).attr("href","#c7");
		   break;
		   case 5:
				$(this).attr("href","#c13");
		   break;
		   case 6:
				$(this).attr("href","#gmaps");
		   break;
	   }
	   
   });
   */
   
   //Sticky Header
	function sticky()
	{
		var window_top=$(window).scrollTop();
		var element_to_stick=$('#wrap-head');
		
		if($(document).width() <= 768) {
			element_to_stick.addClass('in');
		} else {
			if (window_top > 120) {
				element_to_stick.addClass('in');
			} else {
				element_to_stick.removeClass('in');
			}
		}
	}
	
	$(window).scroll(sticky);
	sticky();
	
	
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('#scrollup').addClass("active");
        } else {
            $('#scrollup').removeClass("active");
        }
    });

    $('#scrollup').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });
	
	
	$(".accordion-text").each(function() {
		$(this).attr("data-height",$(this).height());
		$(this).height(0);
	});
	$("li.accordion-item").click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).find(".accordion-text").height(0);
    } else {
      $("li.accordion-item.active").find(".accordion-text").height(0);
      $("li.accordion-item.active").removeClass("active");
      $(this).addClass("active");
      $(this).find(".accordion-text").height(140);
      }		
	});
	
	
	$(".product-wrapper").each(function() {
		$(this).find(".row").each(function() {
			$(this).attr("data-height",($(this).height()+20));
			$(this).hide();
		});
	});
	$(".product-list-item").click(function() {
		if($(this).hasClass("active")) {
			$(this).removeClass("active");
			$(document).find(".product-wrapper").height(0);
			$(".product-content.active").fadeOut();
			$(".product-content.active").removeClass("active");
		} else {
			$(".product-content.active").fadeOut();
			$(".product-content.active").removeClass("active");
			$(".product-list-item.active").removeClass("active");
			$(this).addClass("active");
			$(document).find(".product-wrapper").height(0);
			$(this).parent().parent().find(".product-wrapper").height($("."+$(this).attr("data-content")).attr("data-height"));
			$("."+$(this).attr("data-content")).fadeIn();
			$("."+$(this).attr("data-content")).addClass("active");
		}
	});
	
	if($("body").attr("id") == "page-7") {
		url = location.href.split("#")[0];
		product = url.split("=")[1];
		
		$("#kontakt-multicheckbox-1-"+product).attr("checked","checked");
	}

});



// -----------------------------------------------------------------
// Link Configuration for products and contact form
// -----------------------------------------------------------------
var afterHash = '';
if(document.location.hash.split('=').length == 2) {
    afterHash = decodeURIComponent(document.location.hash.split('=')[1]);
    document.querySelector('#contact-13-multicheckbox-1-' + afterHash).checked = 'true';
    document.querySelector('#c13').scrollIntoView(false);
}









